import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { userSelector } from 'slices/userSlice';
import LogsTable from './LogsTable';
import FullPageLoader from 'components/common/FullPageLoader';
import { fetchInterpreterAppointmentView, fetchInterpreterAppointmentLogs, rescheduleInterpreterAppointment, cancelInterpreterAppointment, addAppointmentNote, updateAppointmentNote, deleteAppointmentNote } from 'slices/interpreter/appointmentSlice';
import NotesTable from 'components/appointment/NotesTable';
import AddNoteModal from 'components/appointment/AddNoteModal';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import toast from 'react-hot-toast';
import { CheckinCheckoutAdjustmentModal } from 'components/appointment/checkinCheckoutAdjustment';
import CouldNotCover from 'components/appointment/CouldNotCover';
import DonotCover from 'components/appointment/DonotCover';
import CancelModal from 'components/appointment/CancelModal';
import RescheduleModal from 'components/appointment/RescheduleModal';
import { setActionAssign } from 'slices/actionButtonSlice';
import ViewTable from 'views/appointment/view/ViewTable';
import moment from 'moment';
import Swal from 'sweetalert2';
import SelectInterpreterModal from 'components/common/SelectInterpreterModal';

const AppointmentView = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector(userSelector);
    const currentUserId = user?.user?.id;

    const [item, setItem] = React.useState({});
    const [loading, setLoading] = React.useState(false)
    const [logs, setLogs] = React.useState([]);
    const [cancelModal, setCancelModal] = React.useState(false);
    const [donotCover, setDonotCover] = React.useState(false);
    const [couldNotCover, setCouldNotCover] = React.useState(false);
    const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);
    const [rescheduleModal, setRescheduleModal] = React.useState(false);
    const [adminCancelModal, setAdminCancelModal] = React.useState(false);
    const [assignInterpreter, setAssignInterpreter] = React.useState(false);
    const [noteModal, setNoteModal] = React.useState(false);
    const [editNoteData, setEditNoteData] = React.useState(null);


    const callViewApi = async () => {
        const callBack = (success, message, data) => {
            setLoading(false);
            if (success) {
                setItem(data)
            }
            else {
                toast.error(message || 'Appointment not accessible.', { className: "errorToast" });
                navigate("/interpreter/dashboard");
            }
        }

        dispatch(fetchInterpreterAppointmentView(id, callBack))
    };

    const fetchLogs = async () => {
        const callBack = (success, message, data) => {
            if (success) {
                setLogs([...(data || [])].sort((a, b) => b.id - a.id))
                console.log(data)
            }
            else {
                console.log(message)
            }
            // setLogs()
        }
        dispatch(fetchInterpreterAppointmentLogs(id, callBack))
    }

    React.useEffect(() => {
        setLoading(true)
        callViewApi();
        fetchLogs();

    }, [id]);
    const handleCancel = () => {
        setCancelModal(true);
    };
    const handleCloseCancel = () => {
        setCancelModal(false);
    };
    const handleDonotCover = () => {
        setDonotCover(true);
    };
    const handleCloseDonotCover = () => {
        setDonotCover(false);
    };
    const handleCouldNotCover = () => {
        setCouldNotCover(true);
    };
    const handleCloseCouldNotCover = () => {
        setCouldNotCover(false);
    };
    const handleOpenCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(true);
    };
    const handleCloseCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(false);
    };
    const handleOpenRescheduleModal = () => {
        setRescheduleModal(true);
    };
    const handleCloseRescheduleModal = () => {
        setRescheduleModal(false);
    };
    const handleOpenAdminCancelModal = () => setAdminCancelModal(true);
    const handleCloseAdminCancelModal = () => setAdminCancelModal(false);
    const handleAssignInterpreter = () => {
        setAssignInterpreter(true);
    };
    const handleCloseAssignInterpreter = () => {
        setAssignInterpreter(false);
    };

    const handleOpenNoteModal = (note = null) => {
        setEditNoteData(note);
        setNoteModal(true);
    };

    const handleCloseNoteModal = () => {
        setNoteModal(false);
        setEditNoteData(null);
    };

    const handleNoteSubmit = (data) => {
        setLoading(true);
        if (editNoteData) {
            dispatch(updateAppointmentNote(data, editNoteData.id, (success, message) => {
                setLoading(false);
                if (success) {
                    toast.success(message, { className: 'successToast' });
                    handleCloseNoteModal();
                    callViewApi();
                } else {
                    toast.error(message, { className: 'errorToast' });
                }
            }));
        } else {
            dispatch(addAppointmentNote({ ...data, appointment_id: id }, (success, message) => {
                setLoading(false);
                if (success) {
                    toast.success(message, { className: 'successToast' });
                    handleCloseNoteModal();
                    callViewApi();
                } else {
                    toast.error(message, { className: 'errorToast' });
                }
            }));
        }
    };

    const handleDeleteNote = (noteId) => {
        new Swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                dispatch(deleteAppointmentNote(noteId, (success, message) => {
                    setLoading(false);
                    if (success) {
                        toast.success(message, { className: 'successToast' });
                        callViewApi();
                    } else {
                        toast.error(message, { className: 'errorToast' });
                    }
                }));
            }
        });
    };
    const handleAdminCancelSubmit = (data) => {
        setLoading(true);
        dispatch(cancelInterpreterAppointment(id, data, (success, message) => {
            setLoading(false);
            handleCloseAdminCancelModal();
            if (success) {
                toast.success(message, { className: 'successToast' });
                callViewApi();
                fetchLogs();
            } else {
                toast.error(message, { className: 'errorToast' });
            }
        }));
    };

    const handleRescheduleSubmit = (data) => {
        setLoading(true);
        dispatch(rescheduleInterpreterAppointment(id, data, (success, message) => {
            setLoading(false);
            handleCloseRescheduleModal();
            if (success) {
                toast.success(message, { className: 'successToast' });
                callViewApi();
                fetchLogs();
            } else {
                toast.error(message, { className: 'errorToast' });
            }
        }));
    };
    const handleSubmit = (data, end_point, callBack , modalTitle = 'Are you sure?') => {
        const submitCallback = (success, message) => {
            callBack && callBack()

            if (success) {
                handleCloseCancel();
                handleCloseDonotCover();
                handleCloseCouldNotCover();
                handleCloseCheckinCheckoutModal();
                handleCloseAssignInterpreter();
                callViewApi();
                fetchLogs();
                toast.success(message, {
                    className: "successToast",
                });
                setLoading(false)
                if (end_point == 'decline-invite' || end_point == 'assign-vendor') {
                    navigate("/interpreter/dashboard");
                }
            }
            else {
                toast.error(message, { className: "errorToast" });

                handleCloseCancel();
                handleCloseDonotCover();
                handleCloseCouldNotCover();
                handleCloseCheckinCheckoutModal();

                navigate("/interpreter/appointments");
                setLoading(false);
            }
        }
        new Swal({
                    title: modalTitle,
                    text: "",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, confirm!',
                })
                    .then((result) => {
                        if (result.isConfirmed) {
                            setLoading(true)

                            dispatch(
                                setActionAssign(
                                    id,
                                    data,
                                    end_point,
                                    submitCallback
                                )
                            )
                        }
                        else {
                            
                        }
                    })
        
        
    }
    const rawDatetime = item?.date + " " + item?.start_time;
    const formattedDate = moment(rawDatetime, 'YYYY-MM-DD HH:mm:ss').format('MMM D, YYYY HH:mm:ss');

    // Show action buttons only if this interpreter is assigned or has a non-rejected invite
    const isAssigned = item?.interpreter?.user?.id === currentUserId;
    const isInvited = item?.invites?.some(invite => invite.status !== 'rejected');
    const canAct = isAssigned || isInvited;
    console.log('this is items',item);
    return (
        <div className="content" style={{}}>
            {loading && <FullPageLoader />}

            <div className="row_main_head bg-primary-secondaryCard">
                <h2 className={`main_heading main_heading1`}>View Appointment # {item?.appid}</h2>

            </div>
            <div className="row_main_head bg-light-secondaryCard asdas">
                <h2 className={`main_heading2 d-flex align-items-center flex-wrap gap-1`} toLowerCase={'text-lowercase'}>Date & Time <span className="dateTime">{formattedDate}</span></h2>
                <div className=''>
                    <div className='text-transform-capitalize main_heading2 d-flex align-items-center flex-wrap gap-1 justify-content-end' >
                        {item?.status && <span className="appointmentType d-block">{(item?.status == 'Under Review'? "Files Uploaded" : item?.status)}</span>}
                        <span className="appLanguage d-block">{item?.language?.name || item?.language_other}</span>
                    </div>
                </div>
            </div>
            {item?.vendor_approval_status === 1 && (
                <div className="d-flex align-items-center gap-3 mt-3 p-3 rounded" style={{ backgroundColor: '#ffce4273' }}>
                    <h3 className="mb-0" style={{ fontSize: '1rem', fontWeight: 500 }}>
                        {item?.excel_requested_by
                            ? <><strong>{item.excel_requested_by}</strong>'s request to send this appointment to Excel has been submitted and is pending admin approval.</>
                            : 'A request to send this appointment to Excel has been submitted and is pending admin approval.'
                        }
                    </h3>
                </div>
            )}
            {item?.vendor_approval_status === 3 && (
                <div className="d-flex align-items-center gap-3 mt-3 p-3 rounded" style={{ backgroundColor: '#f8d7da' }}>
                    <h3 className="mb-0" style={{ fontSize: '1rem', fontWeight: 500, color: '#842029' }}>
                        {item?.excel_requested_by
                            ? <>Admin has declined <strong>{item.excel_requested_by}</strong>'s request to send this appointment to Excel.</>
                            : 'Admin has declined the request to send this appointment to Excel.'
                        }
                    </h3>
                </div>
            )}
            {item?.vendor_id && (
                <div className="d-flex align-items-center gap-3 mt-3 p-3 rounded" style={{ backgroundColor: '#cce5ff', borderLeft: '4px solid #004085' }}>
                    <h3 className="mb-0" style={{ fontSize: '1rem', fontWeight: 500, color: '#004085' }}>
                        This appointment has been forwarded to <strong>{item?.vendor_user?.name === 'Adelina Past' ? 'Excel' : (item?.vendor_user?.name || 'a vendor')}</strong> for coverage.
                    </h3>
                </div>
            )}
            <div className="card_table view_table_custom">
                <div className='row-primary flex-wrap'>
                    {isAssigned && item?.vendor_approval_status === 1 ? (
                        <SubmitButton
                            buttonType="button"
                            className="lightBlue"
                            btnText="Withdraw request sending to Excel"
                            handleSubmit={() => handleSubmit(
                                {},
                                "withdraw-excel-request",
                                () => console.log("Withdraw request successful"),
                                "Are you sure you want to withdraw the request to send this appointment to Excel?"
                            )}
                        />
                    ) : (
                        <>
                            {/* Assigned interpreter only */}
                            {isAssigned && (item?.status == "pending" || item?.status == "assigned") && <SubmitButton buttonType="button" className={'tomatoRed'} btnText="Decline" handleSubmit={handleCancel} />}
                            {isAssigned && item?.status == "pending" &&
                                <SubmitButton
                                    buttonType="button"
                                    btnText="Accept"
                                    handleSubmit={() => handleSubmit(
                                        { interpreter_id: item?.interpreter_id },
                                        "assign",
                                        () => console.log("Appointment accepted successfully!")
                                    )}
                                />
                            }
                            {isAssigned && item?.status == "assigned" &&
                                <SubmitButton buttonType="button" className="Cancle_button"
                                    btnText="Checkin / checkout"
                                    data-bs-toggle="modal"
                                    data-bs-target="#checkinCheckoutAdjustmentModal" handleSubmit={handleOpenCheckinCheckoutModal} />
                            }
                            {isAssigned && item?.status == "assigned" &&
                                <SubmitButton buttonType="button" className="lightBlue"
                                    btnText="Reschedule"
                                    handleSubmit={handleOpenRescheduleModal} />
                            }
                            {isAssigned && (item?.status == "assigned" || item?.status == "pending" || item?.status == "declined") &&
                                <SubmitButton buttonType="button" className={'tomatoRed'}
                                    btnText="Cancel"
                                    handleSubmit={handleOpenAdminCancelModal} />
                            }
                            {isAssigned && item?.status == "declined" && !item?.vendor_approval_status &&
                                <SubmitButton
                                    buttonType="button"
                                    btnText="Send To Excel"
                                    handleSubmit={() => handleSubmit(
                                        { interpreter_id: item?.interpreter_id },
                                        "assign-to-vendor",
                                        () => console.log("Appointment accepted successfully!"),
                                        "Are you sure you want to send this appointment to Excel?"
                                    )}
                                />
                            }

                            {/* Invited interpreter only */}
                            {isInvited && item?.status == "available" &&
                                <>
                                    <SubmitButton
                                        buttonType="button"
                                        btnText="Accept Invite"
                                        handleSubmit={() => handleSubmit(
                                            { interpreter_id: item?.interpreter_id },
                                            "accept-invite",
                                            () => console.log("Appointment accepted successfully!")
                                        )}
                                    />
                                    <SubmitButton
                                        buttonType="button"
                                        btnText="Decline Invite"
                                        className={"tomatoRed"}
                                        handleSubmit={() => handleSubmit(
                                            { interpreter_id: item?.interpreter_id },
                                            "decline-invite",
                                            () => console.log("Appointment accepted successfully!")
                                        )}
                                    />
                                </>
                            }
                            {/* Assign Option (Only for assigned interpreter) */}
                            {isAssigned && ((item?.status === 'assigned' || item?.status === 'pending' || item?.status === 'available' || item?.status === 'declined') && item?.vendor_id == null) ? (
                                <SubmitButton buttonType="button" className={'green'} btnText={item?.status === 'assigned' ? 'Reassign' : 'Assign'} handleSubmit={handleAssignInterpreter} />
                            ) : null}
                        </>
                    )}
                </div>

                <ViewTable item={item} />
            </div>

            <div className="card_table p-4 mb-4">
                <div className="row_main_head mb-3 d-flex justify-content-between align-items-center">
                    <h2 className={`main_heading`}>Notes</h2>
                    {isAssigned && (
                        <SubmitButton 
                            buttonType="button" 
                            className={'green'} 
                            btnText="Add Note" 
                            handleSubmit={() => handleOpenNoteModal()} 
                        />
                    )}
                </div>
                <NotesTable 
                    notes={item?.notes || []} 
                    currentUserId={currentUserId} 
                    onEdit={handleOpenNoteModal} 
                    onDelete={handleDeleteNote} 
                />
            </div>

            <div className="card_table p-4">
                <div className="row_main_head mb-3">
                    <h2 className={`main_heading`}>Appointment Logs</h2>
                </div>
                <LogsTable logs={logs} />
            </div>
            
            <SelectInterpreterModal
                isOpen={assignInterpreter}
                onClose={handleCloseAssignInterpreter}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
                excludeInterpreterId={item?.interpreter?.id}
            />

            <AddNoteModal 
                isOpen={noteModal}
                onClose={handleCloseNoteModal}
                onSubmit={handleNoteSubmit}
                loader={loading}
                editData={editNoteData}
            />

            <CancelModal
                isOpen={cancelModal}
                onClose={handleCloseCancel}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />
            <DonotCover
                isOpen={donotCover}
                onClose={handleCloseDonotCover}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />
            <CouldNotCover
                isOpen={couldNotCover}
                onClose={handleCloseCouldNotCover}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />
            <CheckinCheckoutAdjustmentModal
                isOpen={checkinCheckoutModal}
                handleClose={handleCloseCheckinCheckoutModal}
                onConfirm={handleSubmit}
                appointmentId={id}
                onSubmit={handleSubmit}
                item={item}
                loader={loading}
            />
            <RescheduleModal
                isOpen={rescheduleModal}
                onClose={handleCloseRescheduleModal}
                onConfirm={handleRescheduleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />
            <CancelModal
                isOpen={adminCancelModal}
                onClose={handleCloseAdminCancelModal}
                onConfirm={handleAdminCancelSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
                title="Cancel Appointment"
                btnText="Cancel"
            />
        </div>
    )
}





export default AppointmentView